
import axios, { AxiosResponse } from 'axios';
import { app } from '../configs/appcfg';
export async function ApiLogin(cred: any): Promise<AxiosResponse>{
    const api = axios.create({
        baseURL: `${app.DEFAULT_BACKEND_API}`,
        headers: {
            "content-type": "application/json",
            "accepts": "application/json"
        }
    });
    //return Promise.resolve({data:{...cred,isLoginValid: true, changePasswordRequired: true}});
    return api.post("/users/login",cred);
        
} 
export async function ApiChangePassword(cred: any): Promise<AxiosResponse>{
    const api = axios.create({
        baseURL: `${app.DEFAULT_BACKEND_API}`,
        headers: {
            "content-type": "application/json",
            "accepts": "application/json",
            "authorization": `Bearer ${cred.token}`
        }
    });
    return api.patch(`/thisinhs/${cred.mathisinh}`, {passcode: cred.passcode});
        
} 
export async function ApiChangeSoQuanTrang(cred: any): Promise<AxiosResponse>{
    const api = axios.create({
        baseURL: `${app.DEFAULT_BACKEND_API}`,
        headers: {
            "content-type": "application/json",
            "accepts": "application/json",
            "authorization": `Bearer ${cred.token}`
        }
    });
    
    //return Promise.resolve({data:{...cred,isLoginValid: true, changePasswordRequired: false}});
    return api.patch(`/thisinhs/${cred.mathisinh}`, {vongeo: cred.vongeo});
        
} 
export function ApiProfileGetInfo(queryInfo:any):Promise<any>{
    
    let api = axios.create({
        baseURL: `${app.DEFAULT_BACKEND_API}`,
        headers: {
            "content-type": "application/json",
            "accepts": "application/json",
        }
    });
    return api.post('/users/whois', queryInfo);
}